module.exports = __webpack_public_path__ + "c2c627d9e1bc8d938e640215162bfd2f.pdf";